export default "__VITE_ASSET__45209a16__"